import { render, staticRenderFns } from "./about_component.vue?vue&type=template&id=c8d8645a&scoped=true&"
import script from "./about_component.vue?vue&type=script&lang=js&"
export * from "./about_component.vue?vue&type=script&lang=js&"
import style0 from "./about_component.vue?vue&type=style&index=0&id=c8d8645a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d8645a",
  null
  
)

export default component.exports